import { format } from "date-fns";

import type { CarrierPrice } from "~/shared/schemas/carrier-schema";
import type {
	HandlingUnit,
	QuoteStateType,
} from "~/shared/types/quote-details-types";

export const itemSummary = {
	quantity: { name: "Quantity", type: "display" as const, value: 0 },
	weight: { name: "Weight", type: "display" as const, value: 0 },
	linearFeet: { name: "Linear Feet", type: "display" as const, value: 0 },
	overrideLinearFeet: {
		name: "Override Linear Feet",
		type: "input" as const,
		value: 0,
	},
};

export const addtDetails = [
	"Blind Single",
	"Blind Double",
	"In Bond",
	"Protect From Freezing",
];

export const defaultHandlingUnit: HandlingUnit = {
	id: 0,
	description: "",
	name: "",
	quantity: null,
	unit: {
		id: 6,
		name: "Pallets",
		code: "PLT",
	},
	weight: null,
	density: 0,
	dimensionLength: null,
	length: null,
	dimensionWidth: null,
	width: null,
	dimensionHeight: null,
	height: null,
	class: {
		id: 0,
		name: "",
		code: "",
	},
	nmfc: "",
	isHazmat: false,
	isStackable: false,
	pieceCount: null,
	estClass: 0,
	properShippingName: "",
	unNumber: null,
	hazmatClass: undefined,
	packingGroupId: undefined,
	emergencyContactName: "",
	emergencyContactPhone: "",
};

export const defaultCarrier: CarrierPrice = {
	id: 0,
	quoteId: 0,
	carrierId: 0,
	carrier: {
		id: 0,
		name: "",
		displayName: "",
		tollFreeNumber: "",
		isPreferred: false,
		isCarrierOfTheYear: false,
		isEconomy: false,
		isPartials: false,
		scac: "",
	},
	customerRate: 0,
	distributorRate: null,
	carrierQuoteId: null,
	carrierQuoteExpirationDate: "",
	carrierPriceTypeId: 0,
	carrierPriceType: null,
	serviceLevelId: 0,
	serviceLevel: { id: 0, name: "Select Service Level" },
	serviceAreaTypeId: 0,
	serviceType: "",
	serviceLevelDescription: "",
	destinationTerminalCode: "",
	originTerminalCode: "",
	transitDays: 0,
	maxLiabilityOverride: null,
	maxLiabilityNew: 0,
	maxLiabilityUsed: 0,
	carrierTotalAccessorialCharges: 0,
	carrierTotalAccessorialFuelSurcharges: 0,
	customerTotalAccessorialCharges: 0,
	customerTotalAccessorialFuelSurcharges: 0,
	markedUpCustomerRate: null,
	priceCharges: null,

	eTag: "",
	carrierRate: 0,
	brokerMargin: 0,
};

export const blankCustomer = {
	id: 0,
	name: "",
	hasSignedLTLAddendum: true,
	status: {
		id: 0,
		name: "",
	},
	primaryBroker: {
		id: 0,
		name: "",
		email: "",
	},
	ltlBroker: {
		id: 0,
		name: "",
		email: "",
	},
};

export const blankAddress = {
	id: "",
	postalCode: "",
	latitude: 0,
	longitude: 0,
	city: {
		name: "",
		stateId: "",
		state: {
			id: "",
			abbreviation: "",
			countryCode: "",
			country: {
				abbreviation: "",
				name: "",
			},
			name: "",
		},
		type: "",
	},
};

export const initVal: QuoteStateType = {
	id: 0,
	publicGuid: "",
	templateId: null,
	templateName: null,
	customerAr: {
		id: 0,
		name: "",
		email: "",
		mode: "",
		isBackup: false,
	},
	addtDetails: [],
	pickupCountry: {
		name: "",
		abbreviation: "",
	},
	deliveryCountry: {
		name: "",
		abbreviation: "",
	},
	shipmentDate: format(new Date(), "MM/dd/yyyy"),
	customer: blankCustomer,
	// customerAr: {},
	pickupPostalCode: blankAddress,
	deliveryPostalCode: blankAddress,
	items: [defaultHandlingUnit],
	totalLinearFeet: 0,
	customTotalLinearFeet: 0,
	totalCubicFootage: 0,
	totalDensity: 0,
	deliveryServices: [],
	pickupServices: [],
	poNumber: null,
	poNumbers: "",
	soNumber: "",
	specialInstructions: "",
	customerReference: "",
	emergencyContactName: "",
	emergencyContactPhone: "",
	totalCubicFeet: 0,
	isGuest: false,
	pieceCaseCount: null,
	totalWeight: 0,
	totalQuantity: 0,
	class: "",
	carrierPrices: [],
	quotePreviousRate: null,
	eTag: "",
	createdDate: "",
	expirationDate: "",
	selectedCarrierPriceId: null,
	measuringType: "LB/IN",
	customerCredits: {},
	customerDetails: {
		id: 0,
		name: "",
		hasSignedLTLAddendum: true,
		status: {
			id: 0,
			name: "",
		},
		primaryBroker: {
			id: 0,
			name: "",
			email: "",
		},
		ltlBroker: {
			id: 0,
			name: "",
			email: "",
		},
	},
	insuranceValue: null,
	insuranceApplyType: null,
	insuranceApplyTypeId: null,
	insuranceProductType: null,
	insuranceProductTypeId: null,
	puNumber: null,
	deliveryPO: null,
	hasRoutingGuideMatch: false,
	billingCustomerId: null,
};
